import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";
import { createDonation, updateDonation } from "./donationSlice";
import { importExistingDonors } from "./donorSlice";

// Fetch all pay purposes (with authentication)
export const fetchPayPurpose = createAsyncThunk(
  "paypurpose/fetchPayPurposes",
  async (_, { getState }) => {  
    const { auth } = getState();
    const response = await axiosInstance.get("/api/paypurpose", {
      headers: {
        Authorization: `Bearer ${auth.token}`,
        },
    });
    return response.data;
  }
);

export const deletePayPurpose = createAsyncThunk(
  "paypurpose/deletePayPurpose",
  async (id, { getState }) => {
    const { auth } = getState();
    const response = await axiosInstance.delete(`/api/paypurpose/${id}`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    });
    return response.data;
  }
);

const paypurposeSlice = createSlice({
  name: "paypurpose",
  initialState: {
    paypurpose: [],
    loading: false,
    error: null,    
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchPayPurpose.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchPayPurpose.fulfilled, (state, action) => {
            state.loading = false;
            state.paypurpose = action.payload;
        })
        .addCase(fetchPayPurpose.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
        .addCase(deletePayPurpose.pending, (state) => {
          state.loading = true;
        })
        .addCase(deletePayPurpose.fulfilled, (state, action) => {
          state.loading = false;
          state.paypurpose = state.paypurpose.filter(
            (item) => item._id !== action.meta.arg
          );
        })
        .addCase(deletePayPurpose.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        // Listen to createDonation from donationSlice to add new paypurpose instantly
        .addCase(createDonation.fulfilled, (state, action) => {
          const { paypurpose } = action.payload;
          if (paypurpose) {
            // Add new paypurpose to the beginning of the array
            state.paypurpose.unshift(paypurpose);
          }
        })
        // Listen to updateDonation from donationSlice to update paypurpose instantly
        .addCase(updateDonation.fulfilled, (state, action) => {
          const { updatedPayPurpose } = action.payload;
          if (updatedPayPurpose) {
            // Find and update existing paypurpose or add new one
            const index = state.paypurpose.findIndex(
              (p) => p._id === updatedPayPurpose._id
            );
            if (index !== -1) {
              // Update existing paypurpose
              state.paypurpose[index] = updatedPayPurpose;
            } else {
              // Add new paypurpose (created during update)
              state.paypurpose.unshift(updatedPayPurpose);
            }
          }
        })
        // Listen to importExistingDonors to add new paypurpose records instantly
        .addCase(importExistingDonors.fulfilled, (state, action) => {
          const { insertedPayPurposes } = action.payload;
          if (insertedPayPurposes && insertedPayPurposes.length > 0) {
            // Add new paypurpose records to the beginning of the array
            state.paypurpose = [...insertedPayPurposes, ...state.paypurpose];
          }
        });
    },
});

export default paypurposeSlice.reducer;